import useMediaQueryMUI from '@mui/material/useMediaQuery';

export const TABLET_WIDTH = 768;

export type MediaQuery = {
  isMobile: boolean;
  isTablet: boolean;
  isSmallDesktop: boolean;
  isDesktop: boolean;
  type: 'mobile' | 'tablet' | 'desktop';
};

export const useMediaQuery = (): MediaQuery => {
  /**
   * this hook should  much with src/client/styles/theme/index.tsx
   * to avoid content jumping
   */
  const isTablet = useMediaQueryMUI(`(min-width: ${TABLET_WIDTH}px)`);
  const isSmallDesktop = useMediaQueryMUI('(min-width: 1024px)');
  const isDesktop = useMediaQueryMUI('(min-width: 1280px)');

  return {
    isMobile: !isTablet && !isDesktop,
    isTablet,
    isSmallDesktop,
    isDesktop,
    type: (!isTablet && !isDesktop
      ? 'mobile'
      : isTablet
        ? 'tablet'
        : 'desktop') as 'mobile' | 'tablet' | 'desktop',
  };
};

/** storyblok banner tiles needs exact view port name. Each viewport has its own image */
export const useStoryBlokBannerTileMediaQuery = (): MediaQuery => {
  /**
   * this hook should  much with src/client/styles/theme/index.tsx
   * to avoid content jumping
   */
  const isTabletOrLarger = useMediaQueryMUI(`(min-width: ${TABLET_WIDTH}px)`);
  const isSmallDesktop = useMediaQueryMUI('(min-width: 1024px)');
  const isDesktop = useMediaQueryMUI('(min-width: 1280px)');

  /** conditions for determining the device type should be mutually exclusive */
  return {
    isMobile: !isTabletOrLarger,
    isTablet: isTabletOrLarger && !isDesktop,
    isSmallDesktop,
    isDesktop,
    type: (!isTabletOrLarger ? 'mobile' : isDesktop ? 'desktop' : 'tablet') as
      | 'mobile'
      | 'tablet'
      | 'desktop',
  };
};
